import posthog from "posthog-js";
import Button from "../components/button";
import TextField from "../components/textField";
import { ShowErrorMsg } from "../utils/usePopupMessage";

interface InvitationCodeProps {
  setStep: React.Dispatch<React.SetStateAction<number>>;
  invitationCode: string;
  setInvitationCode: React.Dispatch<React.SetStateAction<string>>;
  loading: boolean;
  setLoading: React.Dispatch<React.SetStateAction<boolean>>;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const InvitationCode = ({
  invitationCode,
  setInvitationCode,
  loading,
  setLoading,
  setIsOpen,
}: InvitationCodeProps) => {
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);

    // Fire-and-forget event capture
    posthog.capture("NewCheckInviteCode_Button_Click", {
      button_location: "InvitationCodePage",
      is_formal_action: true,
      timestamp: new Date().toISOString(),
    });

    await new Promise((resolve) => setTimeout(resolve, 300));
    try {
      const requestParam = { InviteCode: invitationCode };

      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/Promotion/NewCheckInviteCode`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestParam),
        }
      );
      const result = await response.json();
      if (result) {
        if (result.code === 200) {
          setIsOpen(true);
        } else if (response.status === 400) {
          setInvitationCode("");
        } else {
          ShowErrorMsg(result.message);
          setInvitationCode("");
        }
      }
    } catch (error) {
      console.error("error", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <TextField
        id="codeInput"
        imgSrc={`${process.env.PUBLIC_URL}/img/icon.png`}
        imgAlt="J88 Logo"
        label="Vui Lòng Nhập Mã Code"
        type="text"
        value={invitationCode}
        onChange={(e) => setInvitationCode(e.target.value)}
        placeholder="Vui Lòng Nhập Mã Code"
        className="w-full mb-8"
        required
      />
      <div className="flex justify-center">
        <Button type="submit" text={"XÁC NHẬN"} disabled={loading} />
      </div>
    </form>
  );
};

export default InvitationCode;
